/**
 * Emojii flag polyfill for windows
 * Modified From: https://github.com/talkjs/country-flag-emoji-polyfill/blob/master/src/index.ts
 * Removing external deps cruft
 */
function isEmojiSupported(emoji) {
  const ctx = document.createElement('canvas').getContext('2d');
  ctx.canvas.width = ctx.canvas.height = 1;
  ctx.fillText(emoji, -4, 4);
  return ctx.getImageData(0, 0, 1, 1).data[3] > 0; // Not a transparent pixel
}

function doCountryFlagEmojis(
  fontName = 'Twemoji Country Flags',
  fontUrl = 'https://cdn.jsdelivr.net/npm/country-flag-emoji-polyfill@0.1/dist/TwemojiCountryFlags.woff2'
) {
  document.addEventListener('DOMContentLoaded', () => {
    if (isEmojiSupported('😗') && !isEmojiSupported('🇨🇭')) {
      // check to see if its a windows with poor flag
      const style = document.createElement('style');
      style.textContent = `@font-face {
        font-family: "${fontName}";
        unicode-range: U+1F1E6-1F1FF, U+1F3F4, U+E0062-E0063, U+E0065, U+E0067,
          U+E006C, U+E006E, U+E0073-E0074, U+E0077, U+E007F;
        src: url('${fontUrl}') format('woff2');
        font-display: swap;
      }`;
      document.head.appendChild(style);
    }

    document.querySelectorAll('[data-flagify]').forEach((option) => {
      const codeToFlag = (str) => String.fromCodePoint(...str.split('').map((c) => 127397 + c.charCodeAt(0)));
      option.innerHTML = codeToFlag(option.getAttribute('value')) + ' ' + option.innerHTML;
    });
  });
}

doCountryFlagEmojis();
